import { SvgIconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { Center } from '@euler/components/Center';
import { PredefinedHitSlops } from '@euler/functions/predefinedHitSlops';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { MotiView } from 'moti';
import { ComponentType, FC, memo } from 'react';
import { GestureResponderEvent, StyleProp, ViewStyle } from 'react-native';
import { Path, Svg } from 'react-native-svg';

export const kFormElementClearDefaultIconSize = 7.5;

export const FormElementClear = memo(
  ({
    style,
    Icon = DefaultClearIcon,
    iconSize,
    iconColor,
    onPress,
  }: {
    style?: StyleProp<ViewStyle>;
    Icon?: ComponentType<SvgIconProps>;
    iconSize?: number;
    iconColor?: string;
    onPress?: (e: GestureResponderEvent) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    iconSize = iconSize ?? rpx(kFormElementClearDefaultIconSize);
    return (
      <MotiView
        from={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: 'timing', duration: 200 }}
        exit={{ opacity: 0, scale: 0.5 }}
        exitTransition={{ type: 'timing', duration: 200 }}
        style={[
          {
            backgroundColor: '#d0d0d0',
            padding: rpx(4),
            borderRadius: iconSize,
          },
          style,
        ]}
      >
        <Center.Touchable
          activeOpacity={1}
          hitSlop={PredefinedHitSlops.large}
          onPress={onPress}
        >
          <Icon size={iconSize} color={iconColor} />
        </Center.Touchable>
      </MotiView>
    );
  },
);

const DefaultClearIcon: FC<SvgIconProps> = memo(props => {
  const { fill = '#fff', ...svgProps } = useSvgProps(props, 18, 18);
  return (
    <Svg
      viewBox="0 0 1024 1024"
      fill="none"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...svgProps}
    >
      <Path
        d="M631 485.84l309.77-309.78a65.63 65.63 0 0 0 0-92.83 65.63 65.63 0 0 0-92.83 0L538.16 393a37 37 0 0 1-52.32 0L176.06 83.23a65.63 65.63 0 0 0-92.83 0 65.63 65.63 0 0 0 0 92.83L393 485.84a37 37 0 0 1 0 52.32L83.23 847.94a65.63 65.63 0 0 0 0 92.83 65.63 65.63 0 0 0 92.83 0L485.84 631a37 37 0 0 1 52.32 0l309.78 309.77a65.63 65.63 0 0 0 92.83 0 65.63 65.63 0 0 0 0-92.83L631 538.16a37 37 0 0 1 0-52.32z"
        fill={fill}
      />
    </Svg>
  );
});
